import React, { memo } from "react";
import Select from "react-select";
import "./styles.scss";

const MultiSelectDropdown = ({
  onChange = () => {},
  value = [],
  label = "",
  optionsList = [],
  placeholder = "Select...",
  marginBottom = 0,
  disabled = false,
}) => {
  return (
    <div
      className="styled-multi-select-field"
      style={{ padding: "0px", marginBottom: marginBottom }}
    >
      {label.length ? <div className="label-styles">{label}</div> : ""}
      <Select
        options={optionsList}
        isMulti
        isClearable={false}
        classNamePrefix="multi-select-dropdown"
        value={optionsList.filter(function (option) {
          return value.includes(option.value);
        })}
        onChange={onChange}
        isDisabled={disabled}
        placeholder={placeholder}
        styles={{
          option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? "white" : "#8C94A3",
          }),
        }}
      />
    </div>
  );
};

export default memo(MultiSelectDropdown);
